<template>
    <div class="sort-dropdown" :style="dropdownStyle" @mouseleave="closeDropdown">
        <p class="sort-dropdown-title">{{ title }}</p>

        <button v-for="option in primaryOptions" :key="option.value" class="sort-option"
            :class="{ selected: selectedPrimary === option.value }" type="button"
            @click="$emit('select-primary', option)">
            <span class="radio-dot"></span>
            <span>{{ option.label }}</span>
        </button>

        <div v-if="secondaryOptions.length" class="sort-divider"></div>

        <button v-for="option in secondaryOptions" :key="option.value" class="direction-option"
            :class="{ selected: selectedSecondary === option.value }" type="button"
            @click="$emit('select-secondary', option)">
            <img :src="option.icon" alt="" width="16" />
            <span>{{ option.label }}</span>
        </button>
    </div>

</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Sort by'
    },
    primaryOptions: {
      type: Array,
      default: () => []
    },
    secondaryOptions: {
      type: Array,
      default: () => []
    },
    selectedPrimary: {
      type: String,
      default: null
    },
    selectedSecondary: {
      type: String,
      default: null
    },
    dropdownStyle: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    closeOnOutsideClick (e) {
      if (!this.$el.contains(e.target)) {
        this.$emit('close')
      }
    },
    closeDropdown () {
      this.$emit('close')
    }
  },
  mounted () {
    document.addEventListener('click', this.closeOnOutsideClick)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.closeOnOutsideClick)
  }
}
</script>

<style>
.sort-dropdown {
    width: 220px;
    background: #fff;
    border-radius: 8px;
    box-shadow:
        0 6px 16px rgba(0, 0, 0, 0.12),
        0 2px 4px rgba(0, 0, 0, 0.08);
    padding: 12px;
}

.sort-dropdown-title {
    font-size: 11px;
    font-weight: 500;
    color: #6b7280;
    margin-bottom: 8px;
}

.sort-option {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 7px 6px;
    border: none;
    background: transparent;
    cursor: pointer;
    border-radius: 6px;
    font-size: var(--text-xs2);
    font-weight: 400;
    font-family: inherit;
}

.radio-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #f59e0b;
    opacity: 0;
}

.sort-option.selected .radio-dot {
    opacity: 1;
}

.sort-divider {
    height: 1px;
    background: #e5e7eb;
    margin: 8px 0;
}

.direction-option {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 7px 10px;
    border: 1px solid #e5e7eb;
    background: #fff;
    cursor: pointer;
    border-radius: 6px;
    margin-top: 6px;
    font-size: var(--text-xs2);
    font-weight: 400;
    font-family: inherit;
}

.direction-option.selected {
    background: #f1f3f5;
    color: #000000;
    border-color: #f1f3f5;
    background-color: var(--brand-color);
}

.sort-menu-fade-enter-active,
.sort-menu-fade-leave-active {
  transition: opacity 0.30s ease, transform 0.30s ease;
}
.sort-menu-fade-enter,
.sort-menu-fade-leave-to {
  opacity: 0;
  transform: translateY(4px);
}
</style>
